import React from "react";

// Per-page team sort/pick trigger — DEPRECATED. Team selection is now a single
// GLOBAL "Team Surf" control living on the header's big PWHL button (see
// PwhlSectionsBar in Layout.jsx). This component is intentionally a no-op so the
// many pages that still mount <TeamSortToggle/> render nothing extra.
export function TeamSortToggle() {
    return null;
}

export default TeamSortToggle;
